import { HttpClient } from '@angular/common/http';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';

export class MuContextSettings {
  static language(context: string) {
    if (context) {
      return (http: HttpClient) => {
        return new MultiTranslateHttpLoader(http, [
          { prefix: './assets/i18n/', suffix: '.json' },
          { prefix: `/assets/i18n/${context}/`, suffix: '.json' },
        ]);
      };
    }
    return (http: HttpClient) => {
      return new MultiTranslateHttpLoader(http, [{ prefix: './assets/i18n/', suffix: '.json' }]);
    };
  }
}
